/**
 * Central scroll lock for landing / start screen / gameplay canvas.
 */
export type ScrollMode = 'page' | 'start-screen' | 'locked';

export function setScrollMode(mode: ScrollMode): void {
  if (typeof document === 'undefined') return;

  const root = document.documentElement;
  const body = document.body;

  root.style.overscrollBehavior = '';
  body.style.position = '';
  body.style.width = '';
  body.style.top = '';
  body.classList.remove('game-canvas-active');

  switch (mode) {
    case 'page':
      root.style.overflow = '';
      body.style.overflow = '';
      body.style.overflowX = 'hidden';
      break;
    case 'start-screen':
      root.style.overflow = 'hidden';
      body.style.overflow = 'hidden';
      body.style.overflowX = 'hidden';
      body.classList.add('game-canvas-active');
      break;
    case 'locked':
      root.style.overflow = 'hidden';
      body.style.overflow = 'hidden';
      body.style.overflowX = 'hidden';
      root.style.overscrollBehavior = 'none';
      body.classList.add('game-canvas-active');
      break;
  }
}